export default __webpack_public_path__ + "static/media/welcome.5ccdeca3.jpg";